import { render, staticRenderFns } from "./DialogCartella.vue?vue&type=template&id=76261e28"
import script from "./DialogCartella.vue?vue&type=script&lang=js"
export * from "./DialogCartella.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports